export enum GambitType {
  ANY = 'any',
  BLITZ = 'blitz',
  CLASSIC = 'classic',
  RAPID = 'rapid',
  BULLET = 'bullet',
  TIMED = 'timed',
  STREAMED = 'streamed',
  FREESTYLE = 'freestyle',
  BUGHOUSE = 'bughouse',
  HAND_AND_BRAIN = 'hand_and_brain',
  STIMUL = 'stimul',
  LADIES_ONLY = 'ladies_only',
  TOURNAMENT = 'tournament',
  LESSON = 'lesson',
  EVENT = 'event',
  SHOGI = 'shogi',
  GO = 'go',
  BACKGAMMON = 'backgammon',
  CATAN = 'catan',
  SCRABBLE = 'scrabble',
  CARDS = 'cards',
  BOARD_GAMES = 'board_games',
  WALK = 'walk',
  BEGINNER = 'beginner',
  INTERMEDIATE = 'intermediate',
  ADVANCED = 'advanced',
  MUSIC = 'music',
  CURATED = 'curated',
  DONATIONS = 'donations',
}

export enum GambitCategory {
  CASUAL = 'casual',
  TOURNAMENT = 'tournament',
  SOCIALISING = 'event',
  LESSON = 'lesson',
  SPARK = 'spark',
}

export enum GambitInvitationType {
  CHALLENGE = 'challenge',
  REQUEST = 'request',
  SPECTATOR = 'spectator',
}

export enum GambitRepeat {
  NONE = 'none',
  EVERY_DAY = 'every_day',
  EVERY_WEEK = 'every_week',
  EVERY_MONTH = 'every_month',
}

export enum GambitChessSetPolicy {
  CHESS_SET_ORGANIZER = 'chess_set_organizer',
  CHESS_SET_LOCATION = 'chess_set_location',
  CHESS_SET_NEEDED = 'chess_set_needed',
}

/** Where the attendee stands with checking into a gambit in their live banner. */
export enum LiveGambitCheckIn {
  NONE = 'none',
  ACTIVE = 'active',
  LEFT = 'left',
}
